export default "__VITE_ASSET__8_3lG7yK__"